import React, { useEffect } from 'react';
import '../styles/components/loadingNew.scss';

export default function LoadingNew() {
	useEffect(() => {
		const pathList = document.querySelectorAll('path');
		for (const path of pathList) {
			console.log(path.getTotalLength());
		}
	}, []);
	return (
		<div className='parentElement'>
			<svg
				width='187'
				height='29'
				viewBox='0 0 187 29'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				id='loadingAnim'
			>
				<path
					d='M6.52437 23.004H14.8044V27H1.48438V1.87199H6.52437V23.004Z'
					stroke='#775DFE'
					strokeWidth='2'
				/>
				<path
					d='M34.1718 27.252C31.8198 27.252 29.6598 26.7 27.6918 25.596C25.7238 24.492 24.1638 22.968 23.0118 21.024C21.8598 19.056 21.2838 16.836 21.2838 14.364C21.2838 11.916 21.8598 9.71999 23.0118 7.77599C24.1638 5.80799 25.7238 4.27199 27.6918 3.16799C29.6598 2.06399 31.8198 1.51199 34.1718 1.51199C36.5478 1.51199 38.7078 2.06399 40.6518 3.16799C42.6198 4.27199 44.1678 5.80799 45.2958 7.77599C46.4478 9.71999 47.0238 11.916 47.0238 14.364C47.0238 16.836 46.4478 19.056 45.2958 21.024C44.1678 22.968 42.6198 24.492 40.6518 25.596C38.6838 26.7 36.5238 27.252 34.1718 27.252ZM34.1718 22.752C35.6838 22.752 37.0158 22.416 38.1678 21.744C39.3198 21.048 40.2198 20.064 40.8678 18.792C41.5158 17.52 41.8398 16.044 41.8398 14.364C41.8398 12.684 41.5158 11.22 40.8678 9.97199C40.2198 8.69999 39.3198 7.72799 38.1678 7.05599C37.0158 6.38399 35.6838 6.04799 34.1718 6.04799C32.6598 6.04799 31.3158 6.38399 30.1398 7.05599C28.9878 7.72799 28.0878 8.69999 27.4398 9.97199C26.7918 11.22 26.4678 12.684 26.4678 14.364C26.4678 16.044 26.7918 17.52 27.4398 18.792C28.0878 20.064 28.9878 21.048 30.1398 21.744C31.3158 22.416 32.6598 22.752 34.1718 22.752Z'
					stroke='#775DFE'
					strokeWidth='2'
				/>
				<path
					d='M70.6814 22.212H60.6734L59.0174 27H53.7254L62.7614 1.83599H68.6294L77.6654 27H72.3374L70.6814 22.212ZM69.3134 18.18L65.6774 7.66799L62.0414 18.18H69.3134Z'
					stroke='#775DFE'
					strokeWidth='2'
				/>
				<path
					d='M94.327 1.87199C96.967 1.87199 99.283 2.38799 101.275 3.41999C103.291 4.45199 104.839 5.92799 105.919 7.84799C107.023 9.74399 107.575 11.952 107.575 14.472C107.575 16.992 107.023 19.2 105.919 21.096C104.839 22.968 103.291 24.42 101.275 25.452C99.283 26.484 96.967 27 94.327 27H85.543V1.87199H94.327ZM94.147 22.716C96.787 22.716 98.827 21.996 100.267 20.556C101.707 19.116 102.427 17.088 102.427 14.472C102.427 11.856 101.707 9.81599 100.267 8.35199C98.827 6.86399 96.787 6.11999 94.147 6.11999H90.583V22.716H94.147Z'
					stroke='#775DFE'
					strokeWidth='2'
				/>
				<path
					d='M120.888 1.87199V27H115.848V1.87199H120.888Z'
					stroke='#775DFE'
					strokeWidth='2'
				/>
				<path
					d='M151.859 27H146.819L135.407 9.75599V27H130.367V1.83599H135.407L146.819 19.116V1.83599H151.859V27Z'
					stroke='#775DFE'
					strokeWidth='2'
				/>
				<path
					d='M178.836 9.43199C178.26 8.37599 177.468 7.57199 176.46 7.01999C175.452 6.46799 174.276 6.19199 172.932 6.19199C171.444 6.19199 170.124 6.52799 168.972 7.19999C167.82 7.87199 166.92 8.83199 166.272 10.08C165.624 11.328 165.3 12.768 165.3 14.4C165.3 16.08 165.624 17.544 166.272 18.792C166.944 20.04 167.868 21 169.044 21.672C170.22 22.344 171.588 22.68 173.148 22.68C175.068 22.68 176.64 22.176 177.864 21.168C179.088 20.136 179.892 18.708 180.276 16.884H171.636V13.032H185.244V17.424C184.908 19.176 184.188 20.796 183.084 22.284C181.98 23.772 180.552 24.972 178.8 25.884C177.072 26.772 175.128 27.216 172.968 27.216C170.544 27.216 168.348 26.676 166.38 25.596C164.436 24.492 162.9 22.968 161.772 21.024C160.668 19.08 160.116 16.872 160.116 14.4C160.116 11.928 160.668 9.71999 161.772 7.77599C162.9 5.80799 164.436 4.28399 166.38 3.20399C168.348 2.09999 170.532 1.54799 172.932 1.54799C175.764 1.54799 178.224 2.24399 180.312 3.63599C182.4 5.00399 183.84 6.93599 184.632 9.43199H178.836Z'
					stroke='#775DFE'
					strokeWidth='2'
				/>
			</svg>
		</div>
	);
}
